export const types = {
  NAVBAR_SEARCHINPUT_CHANGE: 'Navbar/SEARCHINPUT_CHANGE',
  NAVBAR_STICKY_CHANGE: 'Navbar/STICKY_CHANGE',
  NAVBAR_NAVBARBOOL_CHANGE: 'Navbar/NAVBARBOOL_CHANGE',
  ACCOUNT_MENU_STATUS_CHANGE: 'Navbar/ACCOUNT_MENU_STATUS_CHANGE',
  ACCOUNT_INFORMATION: 'Navbar/ACCOUNT_INFORMATION',
};
